module.exports = __webpack_public_path__ + "static/media/phoneimg.7dc05547.png";